import { apiRequest } from "../../Timetable/utils/http.js";

// Per-campus library of reusable rota templates (structure-only day skeletons).
// Backend contract: docs/backend-ticket-daily-rota.md. Absent endpoint (404)
// degrades to an empty custom list — the built-in starters still show.
export async function listTemplates(campus) {
  const params = new URLSearchParams({ campus });
  try {
    const data = await apiRequest(`api/rota-templates?${params.toString()}`);
    if (Array.isArray(data)) return data;
    return (data && data.templates) || [];
  } catch (e) {
    if (e && e.status === 404) return [];
    throw e;
  }
}

export async function createTemplate({ campus, name, blocks }) {
  return apiRequest(`api/rota-templates`, {
    method: "POST",
    body: { campus, name, blocks },
  });
}

export async function deleteTemplate(id) {
  return apiRequest(`api/rota-templates/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}
